import { LABEL_FILTROS } from '@/config/label-filtros'
import { FORMAS_DE_PAGO } from '@/config/facturae/formas-de-pago'
import { TIPOS_CUENTA } from '@/config/tipos-cuenta'
import { MONEDA_OPERACION } from '@/config/facturae/moneda-operacion'
import { TIPOS_CODIGO_IMPUESTO } from '@/config/facturae/tipos-codigo-impuesto'
import { TIPOS_CATEGORIA_IMPUESTOS } from '@/config/tipos-categoria-impuestos'
import { TIPOS_ASOCIADOS_IVA, TIPOS_ASOCIADOS_IGIC, TIPOS_ASOCIADOS_IPSI } from '@/config/facturae/tipos-asociados'
import { TIPOS_FISCALIDAD_ESPECIAL } from '@/config/facturae/tipos-fiscalidad-especial'
import { TIPOS_PERSONA } from '@/config/facturae/tipos-persona'
import { TIPOS_RESIDENCIA } from '@/config/facturae/tipos-residencia'
import { TIPOS_ROL_ADMINISTRATIVE_CENTER_FB2B } from '@/config/facturae/tipos-rol-administrative-center-fb2b'
import { TIPOS_ROL_ADMINISTRATIVE_CENTER } from '@/config/facturae/tipos-rol-administrative-center'
import { TIPOS_ROL_AGENDA } from '@/config/facturae/tipos-rol-agenda'
import { TIPOS_UNIDADES_MEDIDA } from '@/config/facturae/tipos-unidades-medida'
import { ACCIONES_EMPRESAS } from '@/config/acciones-empresas'
import { DIRE_PREFIX } from '@/config/dire-prefix'
import { TIPOS_IDIOMA } from '@/config/idioma'
import { MESES_USER_PASS_CADUC, MESES_USER_PASS_CADUC_GRID } from '@/config/meses-user-pass-caduc'
import { OPERADORES } from '@/config/operadores'
import { PAISES } from '@/config/paises'
import { PROVINCIAS } from '@/config/provincias'
import { ROLES } from '@/config/roles'
import { TIPOS_AUTH } from '@/config/tipos-auth'
import { TIPOS_AVISO } from '@/config/tipos-aviso'
import { TIPOS_CERT } from '@/config/tipos-cert'
import { TIPOS_CONDICION } from '@/config/tipos-condicion'
import { TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO } from '@/config/tipos-distribuidor-provisionamiento'
import { TIPOS_DISTRIBUIDOR } from '@/config/tipos-distribuidor'
import { CABECERAS_MODULOS, MODULOS, TIPOS_ESTADO, TIPOS_ESTADO_RECEPCION, TIPOS_ESTADO_VERIFACTU, TIPOS_ESTADO_VERIFACTU_DASHBOARD, TIPOS_ESTADO_FILTRO_VERIFACTU, TIPOS_ACCION, TIPOS_OPERACION, TIPOS_CABECERA } from '@/config/tipos-estado'
import { ACCIONES_FLUJO_APROBACION } from '@/config/acciones-flujo-aprobacion'
import { TIPOS_ORIGEN_FACTURA } from '@/config/tipos-origen-factura'
import { TIPOS_GRUPO } from '@/config/tipos-grupo'
import { TIPOS_INVOICE_CLASS } from '@/config/tipos-invoice-class'
import { TIPOS_FACTURA } from '@/config/tipos-factura'
import { TIPOS_CORRECTION_METHOD } from '@/config/tipos-correction-method'
import { TIPOS_METADATOS } from '@/config/tipos-metadato'
import { TIPOS_METADATOS_CREACION } from '@/config/tipos-metadatos-creacion'
import { TIPOS_OTP } from '@/config/tipos-otp'
import { TIPOS_OPERACION_TRIBUTACION } from '@/config/tipos-operacion-tributacion'
import { TIPOS_RECURRENCIA } from '@/config/facturae/tipos-recurrencia'
import { TIPOS_PGE, TIPOS_PGE_RECEPCION, TIPOS_PGE_RECEPCION_IA, PGE_REQUIRE_ADMIN_CENTRE } from '@/config/tipos-pge'
import { TIPOS_PLATAFORMA } from '@/config/tipos-plataforma'
import { TIPOS_SERVICIO } from '@/config/tipos-servicio'
import { TIPOS_TBAI_REGIMEN, TIPOS_TBAI_OPERACION, TIPOS_TBAI_NO_EXENTA, TIPOS_TBAI_NO_SUJETA, TIPOS_HACIENDA, TIPOS_ESTADOS_TBAI } from '@/config/tipos-tbai-config'
import { TIPOS_VERIFACTU_REGIMEN, TIPOS_VERIFACTU_FACTURAS, TIPOS_VERIFACTU_FACTURAS_RECTIFICATIVAS, TIPOS_VERIFACTU_EXENTA, TIPOS_VERIFACTU_NO_EXENTA, TIPOS_VERIFACTU_NO_SUJETA, TIPOS_VERIFACTU_DASHBOARD } from '@/config/tipos-verifactu-config'
import { TIPOS_WEBHOOK_NOTIFICATION, TIPOS_WEBHOOK_EVENT, TIPOS_WEBHOOK_AUTH } from '@/config/tipos-webhook'
import { DASHBOARD_LICENCIAMIENTO } from '@/config/dashboard-licenciamiento'
import { ALLOWED_MODES, ALLOWED_MODE_IDS } from '@/config/allowed-modes'
import { TIPOS_IMPORTACION } from '@/config/tipos-importacion'
import { TIPOS_IMPORTACION_ESTADO } from '@/config/tipos-importacion-estado'
import { TIPOS_FASES_CONFIGURACION } from '@/config/tipos-fases-configuracion'
import { TIPOS_PAQUETES_CONTRATACION } from '@/config/tipos-paquetes-contratacion'
import { TIPOS_POSICION_QR } from '@/config/tipos-posicion-qr'
import { TIPOS_REPORTING_ACTIVO } from '@/config/tipos-reporting-activo'
import { TIPOS_SEPA_GENERADO } from '@/config/tipos-sepa-generado'
import { TIPOS_ESQUEMA } from '@/config/tipos-esquema'
import { WEEK_DAYS } from '@/config/week-days'
import { MONTHS } from '@/config/months'
import { ACTIVE_PERIODS } from '@/config/active-periods'
import { TIPOS_ALERTA, TIPOS_ALERTA_ESTADO } from '@/config/tipos-alerta'
import { TIPOS_RECOBRO } from '@/config/tipos-recobro'
import { OPCIONES_ARCHIVADO } from '@/config/opciones-archivado'

const getDefaultState = () => ({ lastUsed: {}, cache: {} })
  
const state = getDefaultState()
  
const getters = {
  ACCIONES_EMPRESAS,
  ALLOWED_MODES,
  ALLOWED_MODE_IDS,
  CABECERAS_MODULOS,
  DASHBOARD_LICENCIAMIENTO,
  DIRE_PREFIX,
  FORMAS_DE_PAGO,
  LABEL_FILTROS,
  MESES_USER_PASS_CADUC,
  MESES_USER_PASS_CADUC_GRID,
  MODULOS,
  MONEDA_OPERACION,
  OPERADORES,
  OPCIONES_ARCHIVADO,
  PAISES,
  PROVINCIAS,
  ROLES,
  TIPOS_ACCION,
  ACCIONES_FLUJO_APROBACION,
  TIPOS_ASOCIADOS_IGIC,
  TIPOS_ASOCIADOS_IPSI,
  TIPOS_ASOCIADOS_IVA,
  TIPOS_AUTH,
  TIPOS_AVISO,
  TIPOS_CABECERA,
  TIPOS_CERT,
  TIPOS_CODIGO_IMPUESTO,
  TIPOS_CATEGORIA_IMPUESTOS,
  TIPOS_CONDICION,
  TIPOS_CORRECTION_METHOD,
  TIPOS_CUENTA,
  TIPOS_DISTRIBUIDOR,
  TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO,
  TIPOS_ESTADO,
  TIPOS_ESTADOS_TBAI,
  TIPOS_ESTADO_RECEPCION,
  TIPOS_ESTADO_VERIFACTU,
  TIPOS_ESTADO_VERIFACTU_DASHBOARD,
  TIPOS_ESTADO_FILTRO_VERIFACTU,
  TIPOS_FACTURA,
  TIPOS_FISCALIDAD_ESPECIAL,
  TIPOS_GRUPO,
  TIPOS_HACIENDA,
  TIPOS_IDIOMA,
  TIPOS_INVOICE_CLASS,
  TIPOS_METADATOS,
  TIPOS_METADATOS_CREACION,
  TIPOS_OPERACION,
  TIPOS_ORIGEN_FACTURA,
  TIPOS_OTP,
  TIPOS_OPERACION_TRIBUTACION,
  TIPOS_RECURRENCIA,
  TIPOS_PERSONA,
  TIPOS_PGE,
  TIPOS_PGE_RECEPCION,
  TIPOS_PGE_RECEPCION_IA,
  PGE_REQUIRE_ADMIN_CENTRE,
  TIPOS_PLATAFORMA,
  TIPOS_RESIDENCIA,
  TIPOS_ROL_ADMINISTRATIVE_CENTER,
  TIPOS_ROL_ADMINISTRATIVE_CENTER_FB2B,
  TIPOS_ROL_AGENDA,
  TIPOS_SERVICIO,
  TIPOS_VERIFACTU_REGIMEN,
  TIPOS_VERIFACTU_FACTURAS,
  TIPOS_VERIFACTU_FACTURAS_RECTIFICATIVAS,
  TIPOS_VERIFACTU_EXENTA,
  TIPOS_VERIFACTU_NO_EXENTA,
  TIPOS_VERIFACTU_NO_SUJETA,
  TIPOS_VERIFACTU_DASHBOARD,
  TIPOS_TBAI_REGIMEN,
  TIPOS_TBAI_OPERACION,
  TIPOS_TBAI_NO_EXENTA,
  TIPOS_TBAI_NO_SUJETA,
  TIPOS_UNIDADES_MEDIDA,
  TIPOS_WEBHOOK_AUTH,
  TIPOS_WEBHOOK_EVENT,
  TIPOS_WEBHOOK_NOTIFICATION,
  TIPOS_IMPORTACION,
  TIPOS_IMPORTACION_ESTADO,
  TIPOS_FASES_CONFIGURACION,
  TIPOS_PAQUETES_CONTRATACION,
  TIPOS_POSICION_QR,
  TIPOS_REPORTING_ACTIVO,
  TIPOS_SEPA_GENERADO,
  TIPOS_ESQUEMA,
  WEEK_DAYS,
  MONTHS,
  ACTIVE_PERIODS,
  TIPOS_ALERTA,
  TIPOS_ALERTA_ESTADO,
  TIPOS_RECOBRO,
}
  
const mutations = {
  setDefaultState (state) {
    Object.assign(state, getDefaultState())
  },
  setConfig (state, { configName, configData }) {
    state.cache[configName] = configData
    state.lastUsed[configName] = Date.now()
  },
  removeConfig (state, configName) {
    delete state[configName]
    delete state.lastUsed[configName]
  },
  extendCacheTime (state, configName) {
    state.lastUsed[configName] = Date.now()
  }
}
  
const actions = {
  cleanConfigCache ({ commit }) {
    commit('setDefaultState')
  },
  checkInactiveConfigs ({ commit, state }) {
    const now = Date.now()
    for (const configName in state.lastUsed) {
      if (now - state.lastUsed[configName] > 600000) { // 10 minutos de inactividad
        commit('removeConfig', configName)
      }
    }
  },
  extendCacheTime ({ commit }, configName) {
    commit('extendCacheTime', configName)
  },
  loadConfig ({ commit }, config) {
    commit('setConfig', config)
  }
}
  
  
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
